import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import contentfulClient from "../../../../services/contentful";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Footer from "./Footer";
import CardPlan from "./CardPlan";
import Loading from "src/components/Loading";
import * as S from "./styles";
import { addHours, isWithinInterval } from "date-fns";

function Planos() {
  const content = useFetchContent();
  const [loading, setLoading] = useState(false);

  const section = getSection({
    sectionName: "landingDefaultPromo",
    data: content.data,
  });

  const typePlans = ["pedagiosEstacionamentos", "estacionamentos", "pedagios"];
  const plans = useQuery(
    "getCardPlan",
    () =>
      Promise.all(
        typePlans
          .filter((field) => Object.keys(section).includes(field))
          .map(
            async (field) =>
              await contentfulClient.getEntry(section[field].sys.id)
          )
      ),
    {
      enabled: content.data && !content.isLoading,
      retry: false,
    }
  );

  useEffect(() => {
    setLoading(plans.isLoading || content.isLoading);
  }, [plans.isLoading, content.isLoading]);

  useEffect(() => {
    setLoading(plans.isLoading || content.isLoading);
  }, [plans.isLoading, content.isLoading]);

  if (loading || !plans.data) return <Loading />;

  const hasTextBonus = (text, oldText) => {
		const bonusStart = addHours(new Date('2024-10-14'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween && text) return { text, isBold: false }

		return oldText ? { text: oldText, isBold: false } : null
  }

  const showOldText = (text) => {
		const bonusStart = addHours(new Date('2024-10-14'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(!isBetween) return { text, isBold: false }

		return null
  }

  const benefits = [
  {
    text: "Entrega grátis da tag",
    isBold: false,
  },
  {
    text: "Recarga automática no cartão de crédito ou débito next.",
    tooltip: {
      label: "<span> Entenda o que é recarga automática{icon}</span>",
      title:
        "A recarga automática é uma facilidade para você nunca ficar sem saldo!",
      description:
        "Você escolhe o valor para sua primeira recarga, a partir de R$50. Sempre que o saldo da conta chegar em 30%, nós recarregaremos automaticamente no cartão cadastrado. Você também pode acessar o app Veloe e realizar uma recarga adicional de forma manual apenas para compor saldo, se achar necessário.",
    },
    isBold: false,
  },
  {
    text:
      "A partir da segunda tag, a mensalidade será de R$14,90 por tag",
    isBold: false,
  }]

  const firstPromoText = showOldText("Taxa única de adesão de R$20 por tag")
  if(firstPromoText) benefits.unshift(firstPromoText)

  const lastPromoText = hasTextBonus("Adesão <strong>Grátis*</strong>")
  if(lastPromoText) benefits.push(lastPromoText)

  const newPlans = {
    data: [
      {
        fields: {
          benefits,
        },
      },
    ],
  };

  return (
    <S.Container id="plans">
      <S.Title>{section.title}</S.Title>
      <S.Content>
        <S.Plans size={newPlans.data.length}>
          {newPlans.data?.map((plan, index) => (
            <CardPlan
              section={section}
              plans={newPlans}
              item={plan}
              key={index}
            />
          ))}
        </S.Plans>
        <S.MainImage>
          <div>
            <div />
            <img
              src="/tagnext/assets/mockup-cartao-next.svg"
              alt="Bradesco e smartphone"
            />
          </div>
        </S.MainImage>
      </S.Content>
      <Footer
        buttonColor={plans.data[0].fields.corDoBotao}
        terms={section.regulamento}
        textColor={"#FFFFFF"}
        cupons={[plans.data[0].fields.firstButtonCoupon]}
        validade={plans.data[0].fields.validate}
      />
    </S.Container>
  );
}
export default Planos;
